import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Dashboard from "./Dashboard";
import RequireTenantSelection from '../../components/RequireTenantSelection';
import { useAppSelector } from "../../../../store";
import { selectedTenantSelector } from "../../../../store/slice/auth";
const DashboardPage = () => {
    const selectedTenant = useAppSelector(selectedTenantSelector);
    return (_jsx("div", { className: "container-fluid", children: _jsxs("article", { className: "article", children: [_jsx("h2", { className: "home-title", children: "Dashboard" }), _jsx(RequireTenantSelection, { children: selectedTenant?.id && _jsx(Dashboard, { tenant: selectedTenant }) })] }) }));
};
export default DashboardPage;
